import {
  SetTranslationOptions,
  Translation,
  TranslocoService,
} from '@jsverse/transloco';

/** A loader path (without `/{lang}`) preloaded before first paint. */
export interface BootTranslationBundle {
  readonly path: string;
  /** Also merged under this dot path, for keys read outside the loader scope. */
  readonly alias?: string;
}

export const BOOT_TRANSLATION_BUNDLES: readonly BootTranslationBundle[] = [
  { path: 'core' },
  // Used by PermissionGuard / inventory before navbar mounts.
  { path: 'components/navbar', alias: 'components.navbar' },
  // The sidenav renders before its own lazy load would finish.
  { path: 'components/sidenav', alias: 'components.sidenav' },
  { path: 'alerts/form', alias: 'alerts.form' },
  { path: 'alerts/api', alias: 'alerts.api' },
];

export function findBootTranslationBundle(
  bundlePath: string
): BootTranslationBundle | undefined {
  return BOOT_TRANSLATION_BUNDLES.find(bundle => bundle.path === bundlePath);
}

export function applyAliasFromTranslation(
  translocoService: TranslocoService,
  translation: Translation,
  lang: string,
  aliasPath: string,
  options: SetTranslationOptions = {}
): void {
  const aliasSegments = aliasPath.split('.').filter(Boolean);
  if (aliasSegments.length === 0) return;

  const root: Record<string, unknown> = {};
  let cursor = root;
  aliasSegments.forEach((segment, index) => {
    if (index === aliasSegments.length - 1) {
      cursor[segment] = translation;
      return;
    }
    cursor[segment] = {};
    cursor = cursor[segment] as Record<string, unknown>;
  });

  translocoService.setTranslation(root, lang, {
    merge: true,
    ...options,
  });
}
